/**
 * BookingQrFullscreen — QR a pantalla completa sobre fondo blanco (máximo contraste para que el
 * cliente lo escanee desde el teléfono del barbero). Cierra con el botón, Escape o tocando fuera del QR.
 */
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import QRCode from 'react-qr-code';
import { X } from 'lucide-react';
import { tr } from '@/contexts/LanguageContext';

export const BookingQrFullscreen = ({ open, onClose, url, name, avatar }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [open, onClose]);
  if (!open || typeof document === 'undefined') return null;
  return createPortal(
    <div className="fixed inset-0 z-[120] bg-white text-black flex flex-col items-center justify-center px-6" onClick={onClose} data-testid="booking-qr-fullscreen">
      <button type="button" onClick={onClose} className="absolute top-[max(env(safe-area-inset-top),16px)] right-4 w-11 h-11 rounded-full bg-black/5 flex items-center justify-center" aria-label={tr("Cerrar")} data-testid="booking-qr-fullscreen-close">
        <X className="w-5 h-5" />
      </button>
      <div className="flex items-center gap-3 mb-6" onClick={(e) => e.stopPropagation()}>
        {avatar && <img src={avatar} alt="" className="w-12 h-12 rounded-full object-cover border border-black/10" />}
        <div className="text-left">
          <p className="text-[11px] uppercase tracking-[0.3em] font-bold text-[#a8862a]">Ziyup</p>
          <p className="font-display text-xl font-bold leading-tight" data-testid="booking-qr-fullscreen-name">{name}</p>
        </div>
      </div>
      <div className="bg-white p-4 rounded-2xl shadow-[0_0_0_1px_rgba(0,0,0,0.06)]" onClick={(e) => e.stopPropagation()}>
        <QRCode value={url} size={Math.min(typeof window !== 'undefined' ? window.innerWidth - 96 : 320, 420)} level="M" />
      </div>
      <p className="mt-6 text-base font-semibold text-black/80">{tr("Escanea para reservar tu cita")}</p>
      <p className="mt-1 text-xs text-black/50 break-all text-center max-w-xs" data-testid="booking-qr-fullscreen-url">{url}</p>
    </div>,
    document.body,
  );
};

export default BookingQrFullscreen;
